import { Grid, IconButton } from '@mui/material';
import React from 'react';
import GenericModal from '../../../common/components/GenericModal.component';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { modalStyles } from '../../../styles/GenericModalComponentStyles';
import { unitMeasureMessage, unitMeasureInfoVerbiage } from '../../../utils/EstimatePageUtil';

const UnitMeasureMessage = ({
    carePathServiceTypes,
    showUnitMeasureModal,
    setShowUnitMeasureModal,
}) => {
    return (
        <div overflow="hidden">
            <Grid item display="flex" justifyContent="center" alignItems="center">
                <IconButton
                    aria-label="unitMeasureInfo"
                    sx={{
                        marginTop: '-6px',
                        '&.MuiButtonBase-root:focus': {
                            outline: 'none !important',
                        },
                    }}
                    onClick={() => {
                        setShowUnitMeasureModal(true);
                    }}
                >
                    <InfoOutlinedIcon color="primary" />
                </IconButton>
            </Grid>
            <GenericModal
                showModalDialog={showUnitMeasureModal}
                modalStyles={modalStyles}
                modalLabel="UnitMeasure"
                setShowModalDialog={setShowUnitMeasureModal}
                modalTitle={`Cost ${unitMeasureMessage(carePathServiceTypes)}`}
                modalBody={unitMeasureInfoVerbiage(carePathServiceTypes)}
            ></GenericModal>
        </div>
    );
};
export default UnitMeasureMessage;
